import { Routes } from '@angular/router'
import { RoutesEnum } from '@ui-core/enums/routes.enum'
import { dashboardRoutes } from '@ui-features/dashboard/dashboard.routes'
import { honeyTypesRoutes } from '@ui-features/honey-types/honey-types.routes'
import { jobsRoutes } from '@ui-features/jobs/jobs.routes'
import { simulationsRoutes } from '@ui-features/simulations/simulations.routes'
import { specificationsRoutes } from '@ui-features/specifications/specifications.routes'

export const routes: Routes = [
    {
        path: RoutesEnum.FORBIDDEN,
        loadComponent: () => import('@ui-core/ui/error/error').then((m) => m.Error)
    },
    {
        path: RoutesEnum.ERROR_TENANT,
        loadComponent: () => import('@ui-core/ui/error/error').then((m) => m.Error)
    },
    {
        path: RoutesEnum.ERROR_CONFIGURATION,
        loadComponent: () => import('@ui-core/ui/error/error').then((m) => m.Error)
    },
    ...dashboardRoutes,
    ...jobsRoutes,
    ...simulationsRoutes,
    ...specificationsRoutes,
    ...honeyTypesRoutes,

    // This must be at the end of the array to catch all unmatched routes
    {
        path: '**',
        loadComponent: () => import('@ui-core/ui/error/error').then((m) => m.Error)
    }
]
